const TOKEN_PREFIX = '\uE000MD';
const TOKEN_SUFFIX = '\uE001';

function protectMentionsAndReadMore(input: string): { text: string; segments: string[] } {
  const segments: string[] = [];
  let i = 0;
  let text = input.replace(/@\[([^\]]+)\]\((\d+)\)/g, full => {
    segments.push(full);
    return `${TOKEN_PREFIX}${i++}${TOKEN_SUFFIX}`;
  });
  text = text.replace(/\[Read more\]\(task:(\d+)\)/g, full => {
    segments.push(full);
    return `${TOKEN_PREFIX}${i++}${TOKEN_SUFFIX}`;
  });
  return { text, segments };
}

function restorePlaceholders(text: string, segments: string[]): string {
  return text.replace(
    new RegExp(`${TOKEN_PREFIX}(\\d+)${TOKEN_SUFFIX}`, 'g'),
    (_, idx) => segments[parseInt(idx, 10)] ?? ''
  );
}

function stripMarkdownPlain(s: string): string {
  let t = s;
  t = t.replace(/```[\s\S]*?```/g, m => m.replace(/[^\n]/g, ' ').replace(/\n+/g, '\n'));
  t = t.replace(/`([^`]+)`/g, '$1');
  t = t.replace(/\*\*([^*]+)\*\*/g, '$1');
  t = t.replace(/__([^_]+)__/g, '$1');
  t = t.replace(/\*([^*]+)\*/g, '$1');
  t = t.replace(/_([^_]+)_/g, '$1');
  t = t.replace(/~~([^~]+)~~/g, '$1');
  t = t.replace(/==([^=]+)==/g, '$1');
  t = t.replace(/\[([^\]]*)\]\([^)]+\)/g, '$1');
  t = t.replace(/^#{1,6}\s+/gm, '');
  t = t.replace(/^>\s?/gm, '');
  t = t.replace(/^\s*[-*+]\s+\[[ xX]\]\s+/gm, '');
  t = t.replace(/^\s*[-*+]\s+/gm, '');
  t = t.replace(/^\s*\d+\.\s+/gm, '');
  t = t.replace(/\n{3,}/g, '\n\n');
  return t.trim();
}

export function stripMarkdownFormattingForMentions(description: string): string {
  if (!description?.trim()) return description || '';
  const { text, segments } = protectMentionsAndReadMore(description);
  return restorePlaceholders(stripMarkdownPlain(text), segments);
}
